import { shallowEqual, useSelector } from 'react-redux'
import React from 'react'
import { Grid } from '@mui/material'
import { DATA_ADD_LAST_DATA, IMPORT_TYPE, IMPORT_TYPE_TRAITEMENT } from '../../constants/TraitementConstants'
import i18n from 'simple-react-i18n'
import PresentationCard from '../../../components/card/PresentationCard'
import PropTypes from 'prop-types'
import { getSettingInt } from '../../../utils/SettingUtils'
import { hasValue } from '../../../utils/NumberUtil'
import { CAP, TTP, UDI, STATION_INTEGRATION } from 'traitements/constants/TraitementConstants'
import adesLogo from 'assets/pictures/logos/ades.png'
import naiadesLogo from 'assets/pictures/logos/naiades.png'
import orobnatLogo from 'assets/pictures/logos/orobnat.png'

const getDefaultParams = (stationType, applicationSettings) => {
    switch (stationType) {
        case IMPORT_TYPE_TRAITEMENT.ADES_QUALITO:
            return {
                filters: {
                    descriptionImportMode: 'all',
                    selectStationsMode: 'codesMode',
                    syncEvents: true,
                    syncNetworks: true,
                    dontCheckInternalReferences: false,
                    addCodesToADESNetwork: hasValue(getSettingInt(applicationSettings, 'adesQualitoSynchroNetwork')),
                    selectedNetwork: getSettingInt(applicationSettings, 'adesQualitoSynchroNetwork'),
                },
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA],
            }
        case IMPORT_TYPE_TRAITEMENT.NAIADES:
            return {
                filters: [],
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA],
            }
        case IMPORT_TYPE_TRAITEMENT.OROBNAT:
            return {
                filters: {
                    stationTypes: [CAP, TTP, UDI],
                },
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA],
            }
        default:
            return { filters: {}, dataTypes: [] }
    }
}

const updateParams = (stationType, applicationSettings, setFilters, setJobDataTypes) => {
    const params = getDefaultParams(stationType, applicationSettings)
    setFilters(params.filters)
    setJobDataTypes(params.dataTypes)
}


const AddQualitoStepStation = ({
    changeStation,
    nextStep,
    setFilters,
    setJobDataTypes,
    setChoices,
}) => {
    const {
        applicationSettings,
    } = useSelector(store => ({
        applicationSettings: store.AdministrationReducer.applicationSettings,
    }), shallowEqual)

    const centerStyle = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    }

    return (
        <>
            <Grid container justifyContent='center' alignItems='center' spacing={3}>
                <h4>{i18n.newStationStep1}</h4>
            </Grid>
            <Grid container justifyContent='center' alignItems='center' spacing={3} padding={3}>
                <Grid size={6}>
                    <PresentationCard
                        iconComponent={
                            <img
                                className='responsive-img'
                                src={adesLogo}
                                height={70}
                                width={70}
                                style={{
                                    textAlign: 'center',
                                    display: 'table-cell',
                                    verticalAlign: 'middle',
                                }}
                            />
                        }
                        iconContainerStyle={centerStyle}
                        title={i18n.ades}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TYPE: `(${i18n.ades})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE_TRAITEMENT.ADES_QUALITO })
                            updateParams(IMPORT_TYPE_TRAITEMENT.ADES_QUALITO, applicationSettings, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.adesDescription}
                    />
                </Grid>
                <Grid size={6}>
                    <PresentationCard
                        iconComponent={
                            <img
                                className='responsive-img padding-right-1'
                                src={naiadesLogo}
                                height={50}
                                width={100}
                            />
                        }
                        iconContainerStyle={centerStyle}
                        title={i18n.naïades}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TYPE: `(${IMPORT_TYPE.NAIADES})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE_TRAITEMENT.NAIADES })
                            updateParams(IMPORT_TYPE.NAIADES, applicationSettings, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.naiadesDescription}
                    />
                </Grid>
                <Grid size={6}>
                    <PresentationCard
                        iconComponent={
                            <img
                                className='responsive-img padding-right-1'
                                src={orobnatLogo}
                                width={110}
                            />
                        }
                        iconContainerStyle={centerStyle}
                        title={i18n.orobnat}
                        onClick={() => {
                            setChoices(prev => ({
                                ...prev,
                                TYPE: `(${i18n.orobnat})`,
                            }))
                            changeStation({ stationType: IMPORT_TYPE_TRAITEMENT.OROBNAT })
                            updateParams(IMPORT_TYPE_TRAITEMENT.OROBNAT, applicationSettings, setFilters, setJobDataTypes)
                            nextStep()
                        }}
                        description={i18n.OrobnatDescription}
                    />
                </Grid>
            </Grid>
        </>
    )
}

AddQualitoStepStation.propTypes = {
    station: PropTypes.shape({
        stationType: PropTypes.string,
    }),
    setFilters: PropTypes.func,
    setJobDataTypes: PropTypes.func,
    nextStep: PropTypes.func,
    changeStation: PropTypes.func,
    setChoices: PropTypes.func,
}

export default AddQualitoStepStation